export default __webpack_public_path__ + "static/media/closedTickets.d5998a4b.svg";